export var translations = {
    de: {
        phone_label: 'Telefonisch',
        phone_list_1: 'Kostenlos',
        phone_list_2: 'Erfahren Sie Ihre Finanzierungsmöglichkeiten bequem telefonisch von Ihrem persönlichen Experten für Bau-/Immobilienfinanzierung.',
        video_label: 'Bildschirmübertragung',
        video_list_1: 'Kostenlos',
        video_list_2: 'Ihr persönlicher Experte für Bau-/Immobilienfinanzierung zeigt Ihnen per Bildschirmübertragung Ihre Finanzierungsmöglichkeiten.',
        video_list_3: 'Sie sehen den Bildschirm Ihres Experten.',
        video_list_4: 'Sie brauchen keine eigene Kamera.',
        offline_label: 'Filialberatung',
        offline_list_1: 'Kostenlos',
        offline_list_2: 'Besuchen Sie uns für ein Beratungsgespräch nach Verfügbarkeit an einem unserer Standorte.',
        offline_list_3: 'Ihr persönlicher Experte für Bau-/Immobilienfinanzierung wird Sie umfassend über Ihre Finanzierungsmöglichkeiten vor Ort beraten.',
        btnTitle: 'Wählen',
        activeBtnTitle: 'Ausgewählt',
    },
};
